import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { TEAMS_DISPLAY_NAME } from "@constants/team-constants";
import { MembersDuoIcon, SearchDuoIcon, XMarkCircleFillIcon } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
import { getSvgColoredIconCss } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Empty page content for the member teams table */
export function MemberTeamsEmptyPage(t0) {
  const $ = _c(3);
  const {
    status
  } = t0;
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  if (status === "rejected") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyPage title="Error" subtitle={`Failed to fetch the ${TEAMS_DISPLAY_NAME}. Please reload the page and try again.`} icon={_temp} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (debouncedSearchText.length) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyPage title="No results found" subtitle={`There are no ${TEAMS_DISPLAY_NAME} that match this search.`} icon={SearchDuoIcon} />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EmptyPage title={`This member doesn't belong to any ${TEAMS_DISPLAY_NAME} yet`} subtitle="Once this member is added to a team, it will appear here." icon={MembersDuoIcon} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp() {
  return <XMarkCircleFillIcon sx={{
    ...getSvgColoredIconCss(PALETTE_VARS.error.main),
    width: "61px",
    height: "61px"
  }} />;
}